// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Event Modal Component
 * 
 * Displays interactive event notifications with user choices
 * Extracted from EnhancedWarpEventManager for better code organization
 */

import React from 'react';
import { createPortal } from 'react-dom';
import './EnhancedEventNotification.css';

const EventModal = ({
  activeEvent,
  actionFeedback,
  isProcessingAction,
  modalFading,
  onActionSelect,
  onClose
}) => {
  if (!activeEvent) return null;

  return createPortal(
    <div 
      className={`event-overlay ${modalFading ? 'fading' : ''}`}
      onClick={onClose}
    >
      <div 
        className="event-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ borderColor: activeEvent.color }}
      >
        {/* Event Header */}
        <div className="event-header">
          <h2 style={{ color: activeEvent.color }}>
            {activeEvent.title}
          </h2>
          <div className="event-type-badge">
            {activeEvent.type}
          </div>
          {activeEvent.category && (
            <div className="event-category-badge" style={{ 
              background: `rgba(${activeEvent.category === 'minigame' ? '255, 0, 255' : 
                                 activeEvent.category === 'interactive' ? '0, 255, 255' :
                                 activeEvent.category === 'immediate' ? '255, 170, 0' : '68, 68, 68'}, 0.2)`,
              border: `1px solid rgba(${activeEvent.category === 'minigame' ? '255, 0, 255' : 
                                      activeEvent.category === 'interactive' ? '0, 255, 255' :
                                      activeEvent.category === 'immediate' ? '255, 170, 0' : '68, 68, 68'}, 0.5)`,
              color: activeEvent.category === 'minigame' ? '#ff00ff' : 
                     activeEvent.category === 'interactive' ? '#00ffff' :
                     activeEvent.category === 'immediate' ? '#ffaa00' : '#888888'
            }}>
              {activeEvent.category.toUpperCase()}
            </div>
          )}
        </div>

        {/* Event Message */}
        <div className="event-message">
          <p>{activeEvent.message}</p>
        </div>

        {/* Action Feedback */}
        {actionFeedback && (
          <div 
            className="action-feedback"
            style={{ color: actionFeedback.color }}
          >
            {actionFeedback.message}
          </div>
        )}

        {/* Event Actions - Hide after action selected */}
        {!actionFeedback && (
          <div className="event-actions">
            {activeEvent.actions.map((action, index) => (
              <button
                key={index}
                className={`event-action-button ${isProcessingAction ? 'processing' : ''}`}
                onClick={() => onActionSelect(action)}
                disabled={isProcessingAction}
                style={{
                  borderColor: activeEvent.color,
                  boxShadow: `0 0 10px ${activeEvent.color}40`
                }}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default EventModal;
